module.exports = __webpack_public_path__ + "img/wsczzhjkyypt2.814f170e.png";